import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import VideoSDKWrapper from '../components/VideoSDKWrapper';
import Header from '../components/Header';
import Footer from '../components/Footer';

const VideoMeetingPage = () => {
  const location = useLocation();
  const [step, setStep] = useState('setup'); // 'setup' | 'meeting'
  const [participantName, setParticipantName] = useState('');
  const [mode, setMode] = useState('create'); // 'create' | 'join'
  const [joinMeetingId, setJoinMeetingId] = useState('');
  const [selectedMeetingId, setSelectedMeetingId] = useState(null);

  const params = new URLSearchParams(location.search);
  const meetingId = params.get('mid');
  const title = params.get('title') || 'Video Consultation';
  const pname = params.get('pname') || 'Guest';

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-6">
              <h1 className="text-3xl font-bold text-gray-900 mb-6">{title}</h1>
              {!meetingId ? (
                <div className="p-4 bg-yellow-50 border border-yellow-200 text-yellow-800 rounded">
                  No meeting specified. Please use a meeting link generated by Admin.
                </div>
              ) : (
                <VideoSDKWrapper meetingId={meetingId} participantName={pname} />
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VideoMeetingPage;
